import {
  BaseProgressRing,
  type BaseProgressRingProps,
} from "./BaseProgressRing"

type LoadingSpinnerProps = {
  diameter?: BaseProgressRingProps["diameter"]
  hideTrack?: boolean
  trackClassName?: BaseProgressRingProps["trackClassName"]
  progressClassName?: BaseProgressRingProps["progressClassName"]
}

/**
 * A spinner that indicates loading or processing. Avoid multiple spinners on the same screen (consider React.Suspense).
 *
 * ```tsx
 * import { LoadingSpinner } from "@tokenterminal/ui/loading/LoadingSpinner"
 *
 * <LoadingSpinner />
 * ```
 */

export const LoadingSpinner = ({
  diameter = 48,
  hideTrack,
  ...props
}: LoadingSpinnerProps) => {
  let strokeWidth
  if (diameter > 40) {
    strokeWidth = 4
  } else if (diameter > 20) {
    strokeWidth = 2
  } else {
    strokeWidth = 1
  }

  return (
    <BaseProgressRing
      animate
      label="Loading"
      diameter={diameter}
      strokeWidth={strokeWidth}
      trackClassName={hideTrack ? "stroke-transparent" : undefined}
      {...props}
    />
  )
}
